var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { withLiveSiteStyle } from "./useLiveSiteStyle";
import { withNativeStyle } from "./useNativeStyle";
import { withWixStyle } from "./useWixStyle";
const themeStrategy = (_a = {}, isBmPlatform = false) => {
  var _b = _a, { useWixStyles, useNativeStyles } = _b, rest = __objRest(_b, ["useWixStyles", "useNativeStyles"]);
  return useNativeStyles ? withNativeStyle(rest) : (useWixStyles != null ? useWixStyles : isBmPlatform) ? withWixStyle(rest) : withLiveSiteStyle(rest);
};
export {
  themeStrategy
};
//# sourceMappingURL=themeStrategy.js.map
